var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcScienceActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0388 29.5225L25.0001 17.0938V5H27.5001V2.5H12.5001V5H15.0001V17.0938L5.96131 29.5225C4.8496 31.0504 4.68948 33.0729 5.54693 34.7567C6.40438 36.4404 8.13429 37.5005 10.0238 37.5H29.9751C31.8646 37.5005 33.5945 36.4404 34.4519 34.7567C35.3094 33.0729 35.1493 31.0504 34.0376 29.5225H34.0388ZM17.4999 17.9062V5H22.4999V17.9062L25.8412 22.5H14.1587L17.4999 17.9062ZM29.9762 35H10.025C9.07634 34.999 8.20831 34.4663 7.77775 33.621C7.34719 32.7757 7.42675 31.7604 7.98373 30.9925L12.3412 25H27.6587L32.0175 30.9925C32.5745 31.7604 32.654 32.7757 32.2234 33.621C31.7929 34.4663 30.9249 34.999 29.9762 35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcScienceActive);
export default __webpack_public_path__ + "static/media/ic-science-active.18f9b09a.svg";
export { ForwardRef as ReactComponent };